// API設定（相対パスを使用して同じドメインからAPIを呼び出す）
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// デジタルツール認証インスタンス（遅延読み込み）
let digitalToolsAuthInstance = null;

export const setDigitalToolsAuth = (auth) => {
  digitalToolsAuthInstance = auth;
};

// API呼び出しヘルパー関数（認証トークンを自動的に付与）
async function apiCall(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  
  // デジタルツール認証トークンを取得して付与（SSO認証を使用する環境のみ）
  if (digitalToolsAuthInstance && digitalToolsAuthInstance.isAuthenticated()) {
    const token = await digitalToolsAuthInstance.getAuthToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  }
  
  const response = await fetch(url, {
    ...options,
    headers,
  });
  
  // 認証エラーの場合は再認証を試みる
  if (response.status === 401 && digitalToolsAuthInstance) {
    console.log('認証エラーが発生しました。再認証を試みます...');
    const refreshedToken = await digitalToolsAuthInstance.getAuthToken(true);
    if (refreshedToken) {
      headers['Authorization'] = `Bearer ${refreshedToken}`;
      // リトライ
      return fetch(url, {
        ...options,
        headers,
      });
    }
  }
  
  return response;
}

// 在庫管理指標データのバッチ処理を実行
export async function executeZaikokanrisihyo() {
  try {
    const response = await apiCall('/zaikokanrisihyo/execute', {
      method: 'POST',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      // 409エラー（実行中）の場合は特別なメッセージを設定
      if (response.status === 409) {
        throw new Error(errorData.message || 'バッチ処理は既に実行中です。他のユーザーが実行中のため、しばらく待ってから再度お試しください。');
      }
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
      throw new Error(`サーバーに接続できません。サーバーが起動しているか確認してください。 (${API_BASE_URL})`);
    }
    throw error;
  }
}

// 月次分析のバッチ処理を実行
export async function executeGetujibunseki() {
  try {
    const response = await apiCall('/getujibunseki/execute', {
      method: 'POST',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      // 409エラー（実行中）の場合は特別なメッセージを設定
      if (response.status === 409) {
        throw new Error(errorData.message || 'バッチ処理は既に実行中です。他のユーザーが実行中のため、しばらく待ってから再度お試しください。');
      }
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
      throw new Error(`サーバーに接続できません。サーバーが起動しているか確認してください。 (${API_BASE_URL})`);
    }
    throw error;
  }
}

// 月次分析の過去分再集計を実行
export async function executeGetujibunsekiReaggregate({ fiscalYear, months }) {
  try {
    const response = await apiCall('/getujibunseki/reaggregate', {
      method: 'POST',
      body: JSON.stringify({
        fiscalYear,
        months,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      if (response.status === 409) {
        throw new Error(errorData.message || 'バッチ処理は既に実行中です。他のユーザーが実行中のため、しばらく待ってから再度お試しください。');
      }
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
      throw new Error(`サーバーに接続できません。サーバーが起動しているか確認してください。 (${API_BASE_URL})`);
    }
    throw error;
  }
}

